module.exports = __webpack_public_path__ + "static/media/maintenance.1643ba04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/utils/images/originals/maintenance.jpg
// module id = 386
// module chunks = 0